import React from 'react';
import * as Sentry from '@sentry/browser';
import { CaptureConsole as CaptureConsoleIntegration } from '@sentry/integrations';
import { getStorageSync } from '@/utils';
import { reportAndLog } from '@/utils/log';

export type ConfigItem = {
  dsn: string;
  enabled?: boolean; // 是否开启通信
  ignoreErrors?: Array<string | RegExp> | undefined; // 忽略的错误类型
};

export type SentryErrorBoundaryProps = {
  config?: ConfigItem;
};

class SentryErrorBoundary extends React.Component<SentryErrorBoundaryProps, any> {
  componentDidMount() {
    this.init();
  }

  componentDidCatch(error: any, errorInfo: any): void {
    Sentry.withScope((scope) => {
      scope.setExtras(errorInfo);
      Sentry.captureException(error);
    });
    reportAndLog(error.toString(), -1);
  }
  init() {
    const config = this.props.config || {};

    // 设置全局user
    // 貌似没生效
    if (getStorageSync('id_token')) {
      Sentry.configureScope(function(scope) {
        scope.setUser({
          id_token: getStorageSync('id_token')
        });
      });
    }

    Sentry.init({
      ignoreErrors: undefined,
      integrations: [
        new CaptureConsoleIntegration({
          // array of methods that should be captured
          // defaults to ['log', 'info', 'warn', 'error', 'debug', 'assert']
          levels: ['warn', 'error']
        })
      ],

      ...config
    });
  }
  render() {
    return this.props.children;
  }
}

export default SentryErrorBoundary;
